import { IBoxGroup } from 'src/app/models/interfaces/box-group.interface';
import { FormMode } from '../../controls/common/form-mode';

export class BoxGroupFormContext {
    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;

    /**
     * Instance du groupe de bannettes affiché dans le formulaire.
     */
    public item: IBoxGroup;
}
